import { canUseMartialArts, getMonkLevel } from './monk.mjs';
import { isIncapacitated } from './barbarianRage.mjs';
import { getMovementProfile } from './effects/movementProfile.mjs';
import { benefitsFromInvisible } from './effects/invisibility.mjs';

export const MONK_ACTIONS = Object.freeze({
  'bonus-strike': { label:'Bonus Unarmed Strike', level:1, cost:0, attacks:1, martialArts:true },
  flurry: { label:'Flurry of Blows', level:2, cost:1, attacks:2 },
  'patient-defense': { label:'Patient Defense', level:2, cost:0, disengage:true },
  'patient-defense-focus': { label:'Patient Defense · Focus', level:2, cost:1, disengage:true, dodge:true },
  'step-of-the-wind': { label:'Step of the Wind', level:2, cost:0, dash:true },
  'step-of-the-wind-focus': { label:'Step of the Wind · Focus', level:2, cost:1, dash:true, disengage:true, jump:true },
});
/** Unarmed Strikes a Monk action grants; Heightened Focus (Monk 10) makes Flurry of Blows three. */
export const monkActionAttacks = (character, action) => (MONK_ACTIONS[action]?.attacks || 0) + (action === 'flurry' && getMonkLevel(character) >= 10 ? 1 : 0);
/** Heightened Focus: Step of the Wind with Focus carries a willing Large or smaller creature within 5 feet this turn. */
export const STEP_OF_THE_WIND_CARRY = 'monk:step-of-the-wind-carry';
export const monkActionEligible = (character, action) => {
  const definition = MONK_ACTIONS[action];
  return Boolean(definition && getMonkLevel(character) >= definition.level && (!definition.martialArts || canUseMartialArts(character)));
};
export const monkAttackGrant = (combat, actorId) => {
  const ledger = combat?.turnActionLedger;
  return ledger?.combatantId === String(actorId) && ledger?.turnSequence === combat?.turnSequence ? ledger.monkAttacks : null;
};
export const monkJumpMultiplier = (combat, actorId) => {
  const ledger = combat?.turnActionLedger;
  return ledger?.combatantId === String(actorId) && ledger?.turnSequence === combat?.turnSequence
    && ledger.turnStates?.some(state => state.definitionId === 'monk:double-jump') ? 2 : 1;
};
export const dodgeIsEffective = (character = {}, combat = {}, actorId) => {
  character ||= {};combat ||= {};
  if (!(combat.activeEffects || []).some(effect => effect.definitionId === 'action:dodge' && String(effect.targetCombatantId) === String(actorId))) return false;
  const actor = { ...character, combatantId: actorId };
  return !isIncapacitated(actor, combat) && getMovementProfile(actor, combat, actorId).speeds.walk !== 0;
};
export const dodgeAttackSources = ({ target = {}, combatState = {}, targetId, attackerId, targetCanSeeAttacker = true }) => {
  target ||= {};combatState ||= {};
  const local = [...(target.conditions || []), ...(target.statusConditions || [])].map(item => String(item?.name ?? item?.id ?? item).toLowerCase().replace(/^condition:/,''));
  const blinded = local.includes('blinded') || combatState.activeEffects?.some(effect => effect.definitionId === 'condition:blinded' && String(effect.targetCombatantId) === String(targetId));
  return dodgeIsEffective(target, combatState, targetId) && targetCanSeeAttacker && !blinded && !benefitsFromInvisible(combatState, attackerId, targetId) ? ['Target: Dodge'] : [];
};
